import {
  GetConfigurationDTO,
  GetEmissionsConsumptionDTO,
  VWGStockService,
} from '@tribal-worldwide-london/fa-stock-service-vwg';
import {
  GetStockTyreInformationDTO,
  VWGConfigurationService,
} from '@tribal-worldwide-london/fa-configuration-service-vwg';
import { type GlobalStoreStateConfiguration } from '@/stores/globalStore';
import { handleAllErrors } from '../utils/response';
import ContentManager from '@tribal-worldwide-london/fa-content';
import { reduceDataByKey } from '../utils/object';
import { isNotBuildable } from '../utils/storeUtils';

export type StockLoaderFunctionArgs = {
  params: {
    configurations: GlobalStoreStateConfiguration[];
  };
};

export type StockLoaderServiceArgs = {
  stockService: VWGStockService;
  configurationService: VWGConfigurationService;
};

const stockLoader = async (
  { stockService, configurationService }: StockLoaderServiceArgs,
  { params }: StockLoaderFunctionArgs,
  contentManager: Pick<ContentManager, 'get'>
) => {
  const { configurations } = params;
  const stockRequests: Promise<any>[] = [];
  const stockTyreInformationRequests: Promise<any>[] = [];
  const stockEmissionsConsumptionRequests: Promise<any>[] = [];
  const stockSpecOptionsRequests: Promise<any>[] = [];
  const orderNumbers: string[] = [];

  configurations.forEach((app) => {
    const { orderNumber, pdbData } = app;

    if (orderNumber && !isNotBuildable(pdbData)) {
      orderNumbers.push(orderNumber);

      stockRequests.push(
        stockService.getConfiguration(new GetConfigurationDTO(orderNumber))
      );

      stockTyreInformationRequests.push(
        configurationService.getStockTyreInformation(
          new GetStockTyreInformationDTO(orderNumber, true)
        )
      );

      stockEmissionsConsumptionRequests.push(
        stockService.getEmissionsConsumption(
          new GetEmissionsConsumptionDTO(orderNumber)
        )
      );

      stockSpecOptionsRequests.push(
        stockService.getSpecItemsForOrderNumber(orderNumber)
      );
    }
  });

  const stockResponses = await Promise.all([
    Promise.all(stockRequests),
    Promise.all(stockTyreInformationRequests),
    Promise.all(stockEmissionsConsumptionRequests),
    Promise.all(stockSpecOptionsRequests),
  ]);
for (let i = 0; i < stockResponses.length; i++) {
    // Check if the current batch is the last one
    const isLastBatch = (i === stockResponses.length - 1);
    
    // Call the handler with the current batch and the isLastBatch flag
    handleAllErrors(stockResponses[i], contentManager, isLastBatch);
  }

  const stockResponsesByOrderNumber = reduceDataByKey(
    orderNumbers,
    (key: string, i: number) => ({
      [key]: {
        ...stockResponses[0][i].data,
        tyreInformationData: stockResponses[1][i].data,
        emissionsConsumptionData: stockResponses[2][i].data,
        options: stockResponses[3][i].data
      },
    })
  );

  return Promise.resolve(stockResponsesByOrderNumber);
};

export default stockLoader;
